import { render, staticRenderFns } from "./BookSearchContent.vue?vue&type=template&id=8f5dc474&"
import script from "./BookSearchContent.vue?vue&type=script&lang=js&"
export * from "./BookSearchContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports